/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgGitlab(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M4.774 2.396a.277.277 0 01-.002-.007l.002.007zm.313.96l2.13 6.538a.75.75 0 00.712.517h8.1a.75.75 0 00.714-.518l2.123-6.536 2.13 6.556 1.265 3.746a.09.09 0 01-.04.093.755.755 0 00-.032.023l-10.21 7.42-10.205-7.418h-.001a.09.09 0 01-.031-.1l3.345-10.32zm.218-.81l-.003.002.002-.002zM4.294 1.437a1.18 1.18 0 011.591 0l.016.014c.14.136.245.305.303.492l2.27 6.967h7.01l2.272-6.991a1.17 1.17 0 01.32-.483 1.18 1.18 0 011.59 0l.015.015c.14.136.245.306.303.493l2.437 7.5 1.269 3.756.01.03a1.59 1.59 0 01-.643 1.767l-10.637 7.73a.75.75 0 01-.881 0l-10.65-7.74-.004-.002a1.59 1.59 0 01-.569-1.777l3.66-11.29a1.17 1.17 0 01.32-.484l.503.556-.505-.553z'
      />
    </svg>
  );
}

export default SvgGitlab;
